module.exports = __webpack_public_path__ + "img/qilin-f-stage3-blink.02f0ddcb.png";